/** Refresh access token every 14 minutes using the stored refresh token. */
export const REFRESH_TOKEN_INTERVAL_MS = 14 * 60 * 1000;
